
 const Images = [
    {
        url :'https://ritik-kumar-2002.github.io/SortingVisualizer.github.io/',
        image: 'https://repository-images.githubusercontent.com/418043095/ef1c75d3-2635-4d0f-b0c2-d3cc7982decf',
        title:'SORTING ALGORITHM VISUALIZER',
        viewCode: 'https://github.com/Ritik-Kumar-2002/SortingVisualizer.github.io',
    },
    {
        url :'https://ritik-kumar-2002.github.io/LetsGrowMore/',
        image: 'https://letsgrowmore.in/wp-content/uploads/2021/05/cropped-growmore-removebg-preview.png',
        title:'LETS GROW MORE',
        viewCode: 'https://github.com/Ritik-Kumar-2002/LetsGrowMore',
    },
    {
        url :'https://resilient-truffle-44eb62.netlify.app/',
        image:'https://letsgrowmore.in/wp-content/uploads/2021/05/cropped-growmore-removebg-preview.png',
        title:'RANDOM USER',
        viewCode: 'https://github.com/Ritik-Kumar-2002/LetsGrowMoreTask2',
    },
   
 ];
export default Images;